import { render, staticRenderFns } from "./KaspiPay.vue?vue&type=template&id=27649085&scoped=true&"
import script from "./KaspiPay.vue?vue&type=script&lang=js&"
export * from "./KaspiPay.vue?vue&type=script&lang=js&"
import style0 from "./KaspiPay.vue?vue&type=style&index=0&id=27649085&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27649085",
  null
  
)

export default component.exports